import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { FormProvider } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { useUserInfor } from "../../../../Context/User";
import {
    ListarTipoCompromissoController,
    ListarUsuariosAtivosComAcessoCasoController,
} from "../../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { IFiltroListarAgendamento } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { ListarPontosDeVendaController } from "../../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";

interface IFiltrosDeAgendamento extends IFiltroListarAgendamento {}
interface IFilterAgendaAssistenciaTecnicaProps {
    handleFilterFormSubmit(filtro: IFiltrosDeAgendamento): void;
    setTipoAgendamento: Dispatch<
        SetStateAction<"HORARIO_DISPONIVEL" | "HORARIO_AGENDADO" | undefined>
    >;
    filtroInicial: Omit<
        IFiltrosDeAgendamento,
        "DT_FIM" | "DT_INICIO" | "FL_APENAS_MEUS_AGENDAMENTOS"
    >;

    FormMethods: any;
    reset: any;
    getValues: any;
    dateRange: {
        start: Date;
        end: Date;
    };
}

export function FilterAgendaAssistenciaTecnica(
    props: IFilterAgendaAssistenciaTecnicaProps
) {
    const { UserInfor, OrgInfor } = useUserInfor();

    const onSubmit = (data: IFiltrosDeAgendamento) => {
        const currentValues = props.getValues();

        const mergedValues = {
            ...props.filtroInicial,
            ...currentValues,
            ...data,
            DT_INICIO:
                data?.DT_INICIO ||
                currentValues?.DT_INICIO ||
                props.dateRange.start ||
                "",
            DT_FIM:
                data.DT_FIM ||
                currentValues.DT_FIM ||
                props.dateRange.end ||
                "",
        };
        props.handleFilterFormSubmit(mergedValues);
    };

    return (
        <FormProvider {...props.FormMethods}>
            <UnForm handleSubmit={onSubmit} usingContext>
                <div className="form-group row">
                    <div className="col-12">
                        <UnForm.LazySelect
                            label="Empreendimento"
                            controller={ListarEmpreendimentosController}
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            name="ID_PRODUTO"
                        >
                            <option />
                        </UnForm.LazySelect>
                    </div>
                </div>
                {UserInfor.FUNCOES.some(
                    (f) => f.NM_FUNCAO === "ADM_AGENDA_TECNICO"
                ) && (
                    <div className="form-group row">
                        <div className="col-12">
                            <UnForm.LazySelect
                                label="Usuário"
                                controller={
                                    ListarUsuariosAtivosComAcessoCasoController
                                }
                                getDS={(e) => e.DS_NOME}
                                getKeyValue={(e) => e.ID_USUARIO}
                                name="ID_USUARIO"
                            >
                                <option />
                            </UnForm.LazySelect>
                        </div>
                    </div>
                )}
                {UserInfor.FUNCOES.some(
                    (f) => f.NM_FUNCAO === "ADM_AGENDA_TECNICO"
                ) && (
                    <div className="form-group row">
                        <div className="col-12">
                            <UnForm.Select name="ID_TIPO_CASO" label="Modulo">
                                <option></option>
                                {OrgInfor.MODULOS?.map((modulo) => (
                                    <option
                                        key={modulo.ID_MODULO}
                                        value={modulo.ID_MODULO}
                                    >
                                        {modulo.DS_MODULO}
                                    </option>
                                ))}
                            </UnForm.Select>
                        </div>
                    </div>
                )}{" "}
                {UserInfor.FUNCOES.some(
                    (f) => f.NM_FUNCAO === "ADM_AGENDA_TECNICO"
                ) && (
                    <div className="form-group row">
                        <div className="col-12">
                            <UnForm.LazySelect
                                label="Tipo Compromisso"
                                controller={ListarTipoCompromissoController}
                                getDS={(e) => e.DS_TIPO_COMPROMISSO}
                                getKeyValue={(e) => e.ID_TIPO_COMPROMISSO}
                                name="ID_TIPO_COMPROMISSO"
                            >
                                <option />
                            </UnForm.LazySelect>
                        </div>
                    </div>
                )}
                {UserInfor.FUNCOES.some(
                    (f) => f.NM_FUNCAO === "ADM_AGENDA_TECNICO"
                ) && (
                    <div className="form-group row">
                        <div className="col-12">
                            <UnForm.Select
                                label="Tipo Agendamento"
                                name={"TIPO_AGENDAMENTO"}
                                onChange={(e) => {
                                    props.setTipoAgendamento(
                                        e.target.value as
                                            | "HORARIO_DISPONIVEL"
                                            | "HORARIO_AGENDADO"
                                    );
                                }}
                            >
                                <option></option>
                                <option value="HORARIO_DISPONIVEL">
                                    Horários Disponíveis
                                </option>
                                <option value="HORARIO_AGENDADO">
                                    Horários Agendados
                                </option>
                            </UnForm.Select>
                        </div>
                    </div>
                )}
                <div className="form-group row">
                    <div className="col-12">
                        <UnForm.LazySelect
                            label={"Ponto de Venda"}
                            className={`form-control placeholder-dark-75`}
                            name="ID_PONTO_VENDA"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            defaultValue={props.filtroInicial.ID_PONTO_VENDA}
                            controller={ListarPontosDeVendaController}
                            getDS={(s) => s.DS_PONTO_VENDA}
                            getKeyValue={(s) => s.ID_PONTO_VENDA}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-12">
                        <UnForm.Switch
                            label="Apenas Atividades Não Concluídas"
                            name="FL_FILTRAR_VENCIDAS"
                            color="success"
                            defaultChecked={false}
                            type="checkbox"
                        />
                    </div>
                </div>
                <UnForm.SubmitButton
                    className="w-100"
                    wrapperClassName="w-100 d-flex align-items-end justify-content-start mt-3"
                    icon={faFilter}
                    color="dark"
                    outline
                >
                    Filtrar
                </UnForm.SubmitButton>
                <button
                    type="button"
                    onClick={() => {
                        props.reset(props.filtroInicial);
                        props.setTipoAgendamento(undefined);
                    }}
                    className="btn btn-block btn-outline-danger mt-2"
                >
                    <FontAwesomeIcon icon={faTimes} className="mr-2" />
                    Limpar Filtros
                </button>
            </UnForm>
        </FormProvider>
    );
}
